/*
 * @Author: Fan
 * @Date: 2020-04-19 21:42:40
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../typings";
import { inputControlOptions } from ".";
import i18n from "../../../i18n";
/**
 * 选人控件可选类型
 */
export var StaffSelectorSelectType;
(function (StaffSelectorSelectType) {
    /**
     * 所有
     */
    StaffSelectorSelectType["All"] = "all";
    /**
     * 用户
     */
    StaffSelectorSelectType["User"] = "user";
    /**
     * 部门
     */
    StaffSelectorSelectType["Org"] = "org";
})(StaffSelectorSelectType || (StaffSelectorSelectType = {}));
/**
 * 选人控件值类型
 */
export var StaffSelectorValueType;
(function (StaffSelectorValueType) {
    /**
     * 空，取设置的固定值
     */
    StaffSelectorValueType["None"] = "";
    /**
     * 创建人，前发起人
     */
    StaffSelectorValueType["Originator"] = "originator";
    /**
     * 创建人部门，前发起人部门
     */
    StaffSelectorValueType["OriginatorDept"] = "originatorDept";
    /**
     * 引用控件值
     */
    StaffSelectorValueType["Ref"] = "ref";
})(StaffSelectorValueType || (StaffSelectorValueType = {}));
export var DisplayType;
(function (DisplayType) {
    DisplayType["Text"] = "text";
    DisplayType["Tag"] = "tag";
})(DisplayType || (DisplayType = {}));
/**
 * 选人控件
 */
export const staffSelectorOptions = {
    $id: "staffSelectorOptions",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        deptVisible: {
            type: DataType.String,
            title: i18n.t('dataitem.OptionalType').toString(),
            default: StaffSelectorSelectType.All,
        },
        roles: {
            type: DataType.String,
            title: i18n.t('dataitem.RoleScope').toString(),
            default: "",
        },
        mappings: {
            type: DataType.String,
            title: i18n.t('dataitem.Mapping').toString(),
            default: "",
        },
        displayType: {
            type: DataType.String,
            title: "displayType",
            default: DisplayType.Tag,
        },
        multi: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Multi').toString(),
            default: false,
        },
        recursive: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.RecursivelyDisplay').toString(),
            default: false,
        },
        defaultValue: {
            type: DataType.Array,
            title: i18n.t('dataitem.DefaultValue').toString(),
            default: [],
        },
        defaultValueType: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValueType').toString(),
            default: StaffSelectorValueType.None,
        },
    },
};
/**
 * 上传限制
 */
export var UploadLimitType;
(function (UploadLimitType) {
    UploadLimitType["1M"] = "1M";
    UploadLimitType["5M"] = "5M";
    UploadLimitType["10M"] = "10M";
    UploadLimitType["20M"] = "20M";
    UploadLimitType["50M"] = "50M";
    UploadLimitType["100M"] = "100M";
    UploadLimitType["200M"] = "200M";
    // '512M' = '512M',
    // '1G' = '1G'
})(UploadLimitType || (UploadLimitType = {}));
/**
 * 子表显示模式
 */
export var SheetDisplayMode;
(function (SheetDisplayMode) {
    /**
     * 瀑布
     */
    SheetDisplayMode["Waterfall"] = "waterfall";
    /**
     * 分页
     */
    SheetDisplayMode["Page"] = "page";
    /**
     * 二维
     */
    SheetDisplayMode["Table"] = "table";
})(SheetDisplayMode || (SheetDisplayMode = {}));
export const uploadOptions = {
    $id: "uploadOptions",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
            default: "",
        },
        requiredFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.RequiredFormula').toString(),
            default: "",
        },
        limit: {
            type: DataType.String,
            title: i18n.t('dataitem.FileSizeLimit').toString(),
            default: "5M",
        },
        batch: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.BatchDownload').toString(),
            default: true,
        },
    },
};
export const bigUploadOptions = {
    $id: "bigUploadOptions",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
            default: "",
        },
        requiredFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.RequiredFormula').toString(),
            default: "",
        },
        limit: {
            type: DataType.String,
            title: i18n.t('dataitem.FileSizeLimit').toString(),
            default: "5M",
        }
    },
};
export const baseUploadOptions = {
    $id: "baseUploadOptions",
    type: DataType.Object,
    $ref: uploadOptions.$id,
    properties: {
        onUpload: {
            type: DataType.String,
            title: i18n.t('dataitem.UploadEvent').toString(),
            default: "",
        },
        onDelete: {
            type: DataType.String,
            title: i18n.t('dataitem.DeleteEvent').toString(),
            default: "",
        },
    },
};
export const baseBigUploadOptions = {
    $id: "baseBigUploadOptions",
    type: DataType.Object,
    $ref: uploadOptions.$id,
    properties: {
        onUpload: {
            type: DataType.String,
            title: i18n.t('dataitem.UploadEvent').toString(),
            default: "",
        },
        onDelete: {
            type: DataType.String,
            title: i18n.t('dataitem.DeleteEvent').toString(),
            default: "",
        },
    },
};
